<template>
  <div>
    <b-list-group class="list-group-level1">
      <div v-for="item in filterHidden(list)" :key="item.title">
        <b-list-group-item
            :to="item.href"
            class="text-light bg-dark list-group-expand"
            @click="onLinkClick(item)"
        >
          <span>{{ item.title }}</span>
          <b-icon
              icon="caret-right-fill"
              v-if="item.child"
              :rotate="item.rotate || 0"
              class="sidemenu-icon"
          />
        </b-list-group-item>
        <b-collapse :visible="true" v-model="item.visible" v-if="item.child">
          <b-list-group class="list-group-level2">
            <div v-for="item in filterHidden(item.child)" :key="item.title">
              <b-list-group-item
                  :to="item.href"
                  class="text-light bg-dark list-group-expand"
                  @click="onLinkClick(item)"
              >
                <span>{{ item.title }}</span>
                <b-icon
                    icon="caret-right-fill"
                    v-if="item.child"
                    :rotate="item.rotate || 0"
                    class="sidemenu-icon"
                />
              </b-list-group-item>
              <b-collapse v-model="item.visible" v-if="item.child">
                <b-list-group class="list-group-level3">
                  <div
                      v-for="item in filterHidden(item.child)"
                      :key="item.title"
                  >
                    <b-list-group-item
                        :to="item.href"
                        class="text-light bg-dark"
                        @click="onLinkClick(item)"
                    >
                      <span>{{ item.title }}</span>
                    </b-list-group-item>
                  </div>
                </b-list-group>
              </b-collapse>
            </div>
          </b-list-group>
        </b-collapse>
      </div>
    </b-list-group>
  </div>
</template>

<script>
/*global _*/

export default {
  props: ['value', 'menu'],
  data() {
    return {
      list: [],
    };
  },
  watch: {
    menu() {
      this.list = _.cloneDeep(this.menu);
    }
  },
  methods: {
    onLinkClick(item) {
      item.visible = !item.visible;
      item.rotate = item.rotate === 90 ? 0 : 90;
      if (item.href) {
        this.$emit('input', item.title);
      }
    },
    filterHidden(list) {
      return _.filter(list, function (a) {
        return !a.hidden;
      });
    }
  }
};
</script>

<style lang="scss">
.list-group.list-group-level1 {
  padding: 0;
  overflow: hidden;
}

.list-group.list-group-level1 .list-group-expand {
  cursor: pointer;
}

.list-group.list-group-level1 .list-group {
  margin-bottom: 0;
}

.list-group.list-group-level1 .list-group-item {
  border-radius: 0;
  border-width: 1px 0 0 0;
  padding-left: 6px;
}

.list-group.list-group-level1 > .list-group-item:first-child {
  border-top-width: 0;
}

.list-group.list-group-level2 .list-group-item {
  padding-left: 18px;
}

.list-group.list-group-level3 .list-group-item {
  padding-left: 36px;
}

.list-group-item .glyphicon {
  margin-right: 5px;
}

.sidemenu-icon {
  top: 1rem;
  right: 0;
  position: absolute;
}
</style>
